import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { MissionsFiltersRequest } from '../../../models/missions/requests/api-missions-get-request.model';
import { MissionsResultsResponse } from '../../../models/missions/responses/api-missions-results-response.model';
import { MissionUsersResultsResponse } from '../../../models/missions/responses/api-mission-users-results-response.model';
import { MissionRewardsResultsResponse } from '../../../models/missions/responses/api-mission-rewards-results-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiMissionsService {

  constructor(private apiService: ApiService) { }

  getMissions(page: number, resultCount: number, filters: MissionsFiltersRequest): Promise<MissionsResultsResponse> {
    return new Promise<MissionsResultsResponse>((resolve, reject) => {
      const body = { page, result_count: resultCount, filters };
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsGetMissionsUrl, body, MissionsResultsResponse).then(
        (data: MissionsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  getMissionUsers(page: number, resultCount: number, missionId: number): Promise<MissionUsersResultsResponse> {
    return new Promise<MissionUsersResultsResponse>((resolve, reject) => {
      const body = { page, result_count: resultCount, mission_id: missionId };
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsGetMissionUsersUrl, body, MissionUsersResultsResponse).then(
        (data: MissionUsersResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addMission(type: number, startDateTimestamp: number, endDateTimestamp: number, completeQuantity: number, pointsReward: number, customParam: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { type, start_date_timestamp: startDateTimestamp, end_date_timestamp: endDateTimestamp, complete_quantity: completeQuantity, points_reward: pointsReward, custom_param: customParam };
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsAddMissionUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editMission(missionId: number, type: number, startDateTimestamp: number, endDateTimestamp: number, completeQuantity: number, pointsReward: number, customParam: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { mission_id: missionId, type, start_date_timestamp: startDateTimestamp, end_date_timestamp: endDateTimestamp, complete_quantity: completeQuantity, points_reward: pointsReward, custom_param: customParam };
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsEditMissionUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  deleteMission(missionId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsDeleteMissionUrl, { mission_id: missionId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  getMissionsRewards(page: number, resultCount: number, filters: MissionsFiltersRequest): Promise<MissionRewardsResultsResponse> {
    return new Promise<MissionRewardsResultsResponse>((resolve, reject) => {
      const body = { page, result_count: resultCount, filters };
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsGetMissionsRewardsUrl, body, MissionRewardsResultsResponse).then(
        (data: MissionRewardsResultsResponse) => { resolve(data); }, error => { reject(error); });
    });
  }

  addMissionReward(startDateTimestamp: number, endDateTimestamp: number, currencyType: number, currencyQuantity: number, currencyTicketCost: number, pointsRequired: number, pointsRequiredTotal: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { start_date_timestamp: startDateTimestamp, end_date_timestamp: endDateTimestamp, currency_type: currencyType, currency_quantity: currencyQuantity, currency_ticket_cost: currencyTicketCost, points_required: pointsRequired, points_required_total: pointsRequiredTotal };
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsAddMissionRewardUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  editMissionReward(missionRewardId: number, startDateTimestamp: number, endDateTimestamp: number, currencyType: number, currencyQuantity: number, currencyTicketCost: number, pointsRequired: number, pointsRequiredTotal: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      const body = { mission_reward_id: missionRewardId, start_date_timestamp: startDateTimestamp, end_date_timestamp: endDateTimestamp, currency_type: currencyType, currency_quantity: currencyQuantity, currency_ticket_cost: currencyTicketCost, points_required: pointsRequired, points_required_total: pointsRequiredTotal };
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsEditMissionRewardUrl, body).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }

  addMissionsFromFile(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.launchAdminApiRequestPostFile(apiUrls.missionsAddMissionsFromFileUrl, formData);
  }

  addMissionsRewardsFromFile(file: File): Promise<void> {
    const formData = new FormData();
    formData.append('file', file);
    return this.apiService.launchAdminApiRequestPostFile(apiUrls.missionsAddMissionsRewardsFromFileUrl, formData);
  }

  deleteMissionReward(missionRewardId: number): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(apiUrls.missionsDeleteMissionRewardUrl, { mission_reward_id: missionRewardId }).then(
        () => { resolve(); }, error => { reject(error); });
    });
  }
}
